import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import {Box} from "@mui/material";
import Grid from '@mui/material/Grid';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Twitter from '@mui/icons-material/Twitter';
import { EMO_NAME, EMO_EMAIL, EMO_DOMAIN } from '../constants';

function Copyright() {
    return (
        <Typography 
            variant="body1" 
            color="text.secondary"
            sx={{
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                textAlign: { xs: 'center', md: 'left' },
                mb: { xs: 2, md: 0 }
            }}
        >
            {'Copyright © '}
            {new Date().getFullYear()}{'. '}
            <Link color="inherit" href="https://www.emotranscripts.com">
                {EMO_NAME}
            </Link>
        </Typography>
    );
}

export default function Footer() {
    return (
        <Box>
            <Box 
                component="footer"
                sx={{
                    py: { xs: 2, sm: 3, md: 4 },
                    mt: { xs: 2, sm: 3, md: 4 }
                }}
            >
                <Container maxWidth="xl">
                    <Grid 
                        container
                        spacing={ { xs: 2, sm: 3, md: 4 } }
                        direction={{ xs: "column", md: "row" }}
                        justifyContent={{ xs: "center", md: "space-evenly" }}
                        alignItems={{ xs: "center", md: "flex-start" }}
                    >
                        <Grid item xs={12} md="auto">
                            <Copyright/>
                        </Grid>
                        <Grid item xs={12} md="auto">
                            <Typography 
                                variant="body1" 
                                color="text.secondary"
                                sx={{
                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                                    textAlign: { xs: 'center', md: 'left' },
                                    mb: { xs: 2, md: 0 },
                                    wordBreak: 'break-word'
                                }}
                            >
                                Contact us at: <Link href={`mailto:${EMO_EMAIL}`}>{EMO_NAME}</Link>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md="auto">
                            <Box 
                                sx={{ 
                                    display: 'flex', 
                                    gap: { xs: 2, sm: 3 },
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <Link 
                                    href="https://www.facebook.com/" 
                                    color="inherit"
                                    sx={{
                                        '&:hover': { opacity: 0.7 },
                                        transition: 'opacity 0.3s'
                                    }}
                                >
                                    <Facebook sx={{ fontSize: { xs: 24, sm: 28, md: 32 } }} />
                                </Link>
                                <Link
                                    href="https://www.instagram.com/"
                                    color="inherit"
                                    sx={{
                                        '&:hover': { opacity: 0.7 },
                                        transition: 'opacity 0.3s'
                                    }}
                                >
                                    <Instagram sx={{ fontSize: { xs: 24, sm: 28, md: 32 } }} />
                                </Link>
                                <Link 
                                    href="https://www.twitter.com/" 
                                    color="inherit"
                                    sx={{
                                        '&:hover': { opacity: 0.7 },
                                        transition: 'opacity 0.3s'
                                    }}
                                >
                                    <Twitter sx={{ fontSize: { xs: 24, sm: 28, md: 32 } }} />
                                </Link>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
}
